import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteGenericNameApi,
  saveGenericNameManageApi,
} from "../../apiservice/accounts";

export const saveGenericName = createAsyncThunk(
  "genericNames/saveGenericName",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await saveGenericNameManageApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || err.message
      );
    }
  }
);

export const deleteGenericName = createAsyncThunk(
  "genericNames/deleteGenericName",
  async (generic_name_id, { rejectWithValue }) => {
    try {
      const res = await deleteGenericNameApi({
        generic_name_id,
      });

      return res.data;

    } catch (err) {
      return rejectWithValue(
        err.response?.data || err.message
      );
    }
  }
);